import { SelectListWrapper } from 'components/ui/SelectList/SelectListStyles';
import styled from 'styled-components';
import { background, borderColorNotes, darkgrey } from 'styles/Colors';

export const EditLineupMenuWrapper = styled.div`
  svg {
    cursor: pointer;
  }

  ${SelectListWrapper} {
    position: absolute;
    right: 0px;
    top: 40px;
    z-index: 100;
    width: 200px;
    padding: 0;
  }
`;

export const Control = styled.div`
  font-size: 14px;
  cursor: pointer;
  font-family: 'Lato';
  font-size: 15px;
  color: ${darkgrey};
  text-transform: none;
  padding: 16px 10px;

  &:not(:last-child) {
    border-bottom: 1px solid ${borderColorNotes};
  }

  &:hover {
    background-color: ${background};
  }
`;
